'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.SortTypeTypes = void 0;
(function (SortTypeTypes) {
    SortTypeTypes["ALPHANUMERIC"] = "ALPHANUMERIC";
    SortTypeTypes["NUMERIC"] = "NUMERIC";
    SortTypeTypes["CURRENCY"] = "CURRENCY";
    SortTypeTypes["DATE"] = "DATE";
})(exports.SortTypeTypes || (exports.SortTypeTypes = {}));
exports.SortOrderType = void 0;
(function (SortOrderType) {
    SortOrderType["ASCENDING"] = "ascending";
    SortOrderType["DESCENDING"] = "descending";
    SortOrderType["NONE"] = "none";
    SortOrderType["OTHER"] = "other";
})(exports.SortOrderType || (exports.SortOrderType = {}));
//# sourceMappingURL=sortTypes.js.map
